import React from 'react';

export default class Organization extends React.Component {
  constructor(props){
    super(props);

    console.log("organization page init.");
  }

  render() {
    return (
      <div>
        組織1
      </div>
    );
  }
}